module.exports = __webpack_public_path__ + "img/slot_funta.ac45b12a.png";